module.exports = __webpack_public_path__ + "static/media/7.ac4e6987.png";